import { getAllTripsData, getSummaryMetricsData } from '../../api/trips';
import {updateUserTripColumnList} from '../../api/genericConsignmentView';

const viewControl = {
  buckets : [
    'retail_all',
    'retail_created',
    'retail_assigned',
    'retail_started',
    'retail_completed',
  ],
  fetchData : getAllTripsData,
  fetchSummaryMetrics : getSummaryMetricsData,
  updateUserColumnList: updateUserTripColumnList,
};

const buckets = {
  retail_all : {
    name:'All',
    color:'#7047BC',
    filters : [
      'trip_type',
      'vehicle_type',
      'vehicleType',
      'route_search',
      'is_hand_delivery_trip',
    ],
    actions: ['downloads'],
    rowSelection : false,
    status_filter : [],
    defaultSortBy: 'last_main_event_time',
  },
  retail_created :{
    name:'Created',
    color:'#7047BC',
    filters : [
      'trip_type',
      'vehicle_type',
      'vehicleType',
      'route_search',
      'is_hand_delivery_trip',
    ],
    actions: [
      'delete',
    ],
    rowSelection : true,
    status_filter : [],
    defaultSortBy: 'last_main_event_time',
  },
  retail_assigned : {
    name:'Assigned',
    color:'#7CBE28',
    filters : [
      'trip_type',
      'vehicle_type',
      'vehicleType',
      'route_search',
      'is_hand_delivery_trip',
    ],
    actions: [
      'delete',
    ],
    rowSelection : true,
    status_filter : [],
    defaultSortBy: 'last_main_event_time',
  },
  retail_started : {
    name:'Started',
    color:'#4782BC',
    filters : [
      'trip_type',
      'vehicle_type',
      'vehicleType',
      'route_search',
      'is_hand_delivery_trip',
    ],
    actions: [
    ],
    rowSelection : false,
    status_filter : [],
    defaultSortBy: 'last_main_event_time',
  },
  retail_completed : {
    name:'Completed',
    color:'#47BC9C',
    filters : [
      'trip_type',
      'vehicle_type',
      'vehicleType',
      'route_search',
      'is_hand_delivery_trip',
    ],
    actions: [],
    rowSelection : false,
    status_filter : [],
    defaultSortBy: 'last_main_event_time',
  },
  retail_inbound : {
    name:'In Bound',
    color:'#47BC9C',
    filters : [
      'trip_type',
      'vehicle_type',
      'vehicleType',
      'route_search',
      'settlement',
      'is_hand_delivery_trip',
    ],
    actions: [],
    rowSelection : false,
    status_filter : [],
    defaultSortBy: 'last_main_event_time',
  },
};
const bucketColor = {
  retail_all : '#7047BC',
  retail_created : '#7047BC',
  retail_assigned : '#7CBE28',
  retail_started : '#4782BC',
  retail_completed : '#47BC9C',
};

export default { viewControl, bucketColor, buckets };
